<template>

    <div class="wrapper-style result-wrapper rd-approach">
        <div class="fix-bg">
            <div class="bgview">
                <div class="gradient-cover"></div>
            </div>
        </div>
        <div class="page-box">
            <div class="bgview" id="rd-scroller" @scroll="handleScroll">
                <div class="fix-btn" id="rd-fix-btn" v-on:click="scrollMassage">
                    <div class="view">
                        <p>往下滑看任務細節</p>
                        <p>領按摩金、抽萬元 SPA 行程</p>
                    </div>
                </div>
                <div class="header">
                    <div class="view">
                        <div class="left">
                            <div class="header-funnow-logo">
                                <div class="bgshow"></div>
                            </div>
                        </div>
                        <div class="header-event-logo">
                            <div class="bgshow"></div>
                        </div>
                    </div>
                </div>
                <div class="result-tvbox" id="rd-section-1">

                    <div class="wave-bg"></div>
                    <div class="result-show-tit">
                        <div class="view">
                            <p>勞累型態：<span v-text="result.data.name">不敢說真話的累</span></p>
                        </div>
                    </div>
                    <div class="tv-box" v-bind:style="{ 'background-image': 'url(' + path+result.song.image_result+'.png' + ')' }">
<!--                        <div class="number">-->
<!--                            <div class="box">-->
<!--                                <div class="show">-->
<!--                                    <p>66%</p>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="viewbox">
                            <div class="box">
                                <div class="img-box">
                                    <div class="img-view"></div>
                                </div>

                                <div class="song">
                                    <div class="view">
                                        <p>演唱：林宥嘉</p>
                                        <p>改編：FunNow×Dcard</p>
                                    </div>
                                </div>
                                <ul class="ul">
                                    <li>
                                        <div class="view">
                                            <p>心累程度</p>
                                            <p><span>💔💔</span></p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="view">
                                            <p>翻白眼頻率</p>
                                            <p><span>2 次/分鐘</span></p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="view">
                                            <p>過勞指數</p>
                                            <p><span>179%</span></p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="tv-key">
                        <div class="view">
                            <p v-text="result.data.golden_sentence"></p>
                        </div>
                    </div>
                    <div class="tv-des">
                        <template v-for="tag in result.data.has_tags">
                            <p v-html="'<span>#</span> '+tag"></p>
                        </template>
                        <p class="col-red" v-text="result.data.funnow_text"></p>
                    </div>

                    <div class="tag-show">
                        <p>tag @dcard.tw @funnow.tw IG</p>
                        <p class="col-red">抽萬元按摩行程！</p>
                    </div>
                    <button type="button" class="red-btn mb-style" id="rd-share-button" v-on:click="openShare">
                        <span>取得結果圖</span>
                    </button>
                    <div class="wave-bg-line marb-24"></div>
                </div>
                <div class="result-show-box">
                    <div class="area-box marb-24" id="rd-section-2">
                        <div class="box-view">
                            <div class="line-b"></div>
                            <div class="line-t"></div>
                            <div class="line-r"></div>
                            <div class="line-l"></div>
                            <div class="bg-t-l">
                                <div class="bgshow"></div>
                            </div>
                            <div class="bg-t-r">
                                <div class="bgshow"></div>
                            </div>
                            <div class="bg-b-l">
                                <div class="bgshow"></div>
                            </div>
                            <div class="bg-b-r">
                                <div class="bgshow"></div>
                            </div>
                            <div class="view">
                                <div class="result-logo"></div>
                                <h5>讓你的疲累有出口!</h5>
                                <div class="area-tit">
                                    <div class="show">✨五一按摩節，全月送 $510 按摩金✨</div>
                                </div>
                                <ul class="marb-12">
                                    <li>下載 FunNow 輸入優惠碼【Dcard】 首次預訂折$150</li>
                                    <li>按完一次，送 $360 按摩金繼續按！</li>
                                </ul>
                                <button type="button" class="bl-btn marb-24" v-on:click="clickMassage">
                                    <span>馬上去按摩 👉🏻</span>
                                </button>
                                <div class="area-tit">
                                    <div class="show">下載 Dcard ，抽萬元 SPA 行程</div>
                                </div>
                                <ul class="marb-12">
                                    <li>新註冊秒拿 85 折按摩優惠</li>
                                    <li>下載 Dcard 留言拿 9 折按摩優惠，再抽總價萬元 SPA 行程</li>
                                    <li>詳情請看「工作板」置頂文</li>
                                </ul>
                                <button type="button" class="bl-btn marb-24" v-on:click="clickDiscount" v-if="auth">
                                    <span>我要抽萬元 SPA 👉🏻</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="wave-bg-line marb-24"></div>
                    <div class="show-tit" id="rd-section-3">
                        <div class="view">
                            <p>用 <span class="col-red">FunNow</span></p>
                            <p>隨時預約鬆一下</p>
                        </div>
                    </div>
                    <div class="funnow-relax marb-24">
                        <div class="hock"><div class="view"></div></div>
                        <div class="show">
                            <div class="img-box">
                                <div class="view"></div>
                            </div>
                            <div class="microphone"></div>
                        </div>
                        <button type="button" class="red-btn marb-24" v-on:click="clickMoreDiscount">
                            <span>更多按摩優惠</span>
                        </button>
                    </div>

                    <div class="show-tit">
                        <div class="view">
                            <p>解放你的社畜魂！</p>
                            <p>加入 <span class="col-red">Dcard</span> 豐富你的下班生活</p>
                        </div>
                    </div>
                    <div class="join-dcard">
                        <div class="hock"><div class="view"></div></div>
                        <div class="show">
                            <div class="img-box">
                                <div class="view"></div>
                            </div>
                            <div class="microphone"></div>
                        </div>
                        <button type="button" class="red-btn" v-on:click="clickDownload">
                            <span>立即下載</span>
                        </button>
                    </div>
                </div>
                <div class="copyright">
                    <p>Copyright © 2023 Dcard Holdings Ltd.</p>
                    <p>All Rights Reserved.</p>
                </div>
            </div>
        </div>
        <div class="fix-share" id="rd-fix-share">
            <div class="bg"><div class="show"></div></div>
            <div class="view">
                <div class="share-logo"></div>
                <button type="button" v-on:click="openShareFloat"></button>
            </div>
        </div>
    </div>

</template>

<script>

import {gsap} from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

export default {
    name:"Result",
    props: ["path", "result", "uid", "auth"],
    data() {
        return {
            isMobile: false,
            showSharing: false,
        }
    },
    methods: {
        openShare() {
            this.$gtag.event('click_result_pic')
            this.$gtag.event(this.result.data.ga.click_result_pic)
            this.addHashToLocation()
            this.$emit('switch-component', 'share')
        },
        openShareFloat() {
            this.$gtag.event('click_floating_button')
            this.$gtag.event(this.result.data.ga.click_floating_button)
            this.addHashToLocation()
            this.$emit('switch-component', 'share')
        },
        addHashToLocation() {
            const queryString = window.location.search;
            let urlParams = new URLSearchParams(queryString);

            urlParams.set('share', true)
            history.pushState(
                {},
                null,
                process.env.MIX_APP_URL +'?'+ urlParams.toString()
            )
        },
        clickMassage(){
            this.$gtag.event('click_funnow')
            this.$gtag.event(this.result.data.ga.click_funnow)
            window.open("https://funnow.page.link/2023MSG_Dcard_Test")
        },
        clickDiscount(){
            this.$gtag.event('click_dcard')
            this.$gtag.event(this.result.data.ga.click_dcard)
            window.open("https://dcard.onelink.me/TOtb/2uxsnkoy")
        },
        clickMoreDiscount(){
            this.$gtag.event('click_massage')
            this.$gtag.event(this.result.data.ga.click_massage)
            window.open("https://eme2c.app.goo.gl/2023MSG_Dcard_ReadMore")
        },
        clickDownload(){
            this.$gtag.event('click_donwload')
            this.$gtag.event(this.result.data.ga.click_donwload)
            window.open("https://dcard.onelink.me/TOtb/2uxsnkoy")
        },
        scrollEvent(){
            const _this = this

            ScrollTrigger.create({
                scroller: "#rd-scroller",
                trigger: "#rd-share-button",
                start: "top-=30% top",
                markers:false,
                onEnter: function () {
                    gsap.to('#rd-fix-share', {opacity:0})
                },
                onEnterBack: function () {
                    gsap.to('#rd-fix-share', {opacity:0})
                },
                onLeave: function () {
                    gsap.to('#rd-fix-share', {opacity:1})
                }
            });

            ScrollTrigger.create({
                scroller: "#rd-scroller",
                trigger: "#rd-section-1",
                start: "top-=30% top",
                markers:false,
                onEnter: function () {
                    _this.$gtag.event('view_result_firstscreen')
                }
            });
            ScrollTrigger.create({
                scroller: "#rd-scroller",
                trigger: "#rd-section-2",
                start: "top-=30% top",
                markers:false,
                onEnter: function () {
                    _this.$gtag.event('view_result_secendscreen')
                }
            });
            ScrollTrigger.create({
                scroller: "#rd-scroller",
                trigger: "#rd-section-3",
                start: "top-=30% top",
                markers:false,
                onEnter: function () {
                    _this.$gtag.event('view_result_thirdscreen')
                }
            });
        },
        scrollMassage(){
            gsap.to('#rd-scroller', {duration: 1.5, scrollTo: {y: "#rd-section-2", offsetY: 50}});
        },
        handleScroll(event){

            let limit = 0

            if(this.isMobile){
                limit = 100
            }

            if(event.currentTarget.scrollTop <= limit){
                gsap.to('#rd-fix-btn', {autoAlpha:1})
            }else{
                gsap.to('#rd-fix-btn', {autoAlpha:0})
            }
        },
        resizeEvent(){
            // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
            let vh = window.innerHeight * 0.01;
            // Then we set the value in the --vh custom property to the root of the document
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }
    },
    mounted: function () {
        const _this = this
        this.$gtag.event('view_result')
        this.$gtag.event(this.result.data.ga.view_result)
        this.isMobile = !!window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        this.$emit('approach-animate')

        this.scrollEvent()
        _this.resizeEvent()
        window.addEventListener("resize", function () {
            _this.resizeEvent()
        });
    }
}


</script>
